import React from 'react';
import Clock from '../Clock';
import { create } from 'react-test-renderer';
import { render, screen } from '@testing-library/react';

describe('Clock Component', () => {
  it('should be defined', () => {
    const { container } = render(<Clock />);
    expect(container).toBeDefined();
  });

  it('renders clock-hand', () => {
    render(<Clock hour={4} />);
    expect(screen.queryByTestId('clockhand')).toBeDefined();
  });

  it('renders clock with hour24 style', () => {
    render(<Clock hour={4} hour24={true} />);
    expect(screen.getByText('0')).toBeDefined();
  });

  it('renders Hours with selected one', () => {
    const selectedHour = 4;
    render(<Clock hour24 hour={selectedHour} displayMode='hh' />);
    const selectedItem = screen.getByTestId('selectedHour');
    expect(selectedItem).toBeDefined();
    expect(selectedItem.textContent).toBe(selectedHour.toString());
  });

  it('renders Minutes with selected one', () => {
    const selectedMinutes = 40;
    render(<Clock minute={selectedMinutes} displayMode='mm' />);
    const selectedItem = screen.getByTestId('selectedMinute');

    expect(selectedItem).toBeDefined();
    expect(selectedItem.textContent).toBe(selectedMinutes.toString());
  });

  it('renders Seconds with selected one', () => {
    const selectedSeconds = 50;
    render(<Clock second={selectedSeconds} displayMode='ss' />);
    const selectedItem = screen.getByTestId('selectedSecond');
    expect(selectedItem).toBeDefined();
    expect(selectedItem.textContent).toBe(selectedSeconds.toString());
  });

  describe('snapshots', () => {
    it('should match all props given snapshot', () => {
      const component = create(
        <div className='core-timepicker'>
          <Clock size={400} hour24={true} hour={4} minute={50} second={40} displayMode='hh' />
        </div>
      ).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
